import { defineComponent, PropType } from "vue";

export const LogsLoadMoreFooter = defineComponent({
    props: {
        loading: {
            type: Boolean,
            required: true,
        },
        hasMore: {
            type: Boolean,
            required: true,
        },
        icon: {
            type: String,
            default: undefined,
        },
        label: {
            type: String,
            default: "Rechercher plus",
        },
        loadingLabel: {
            type: String,
            default: "Chargement…",
        },
        onloadMore: {
            type: Function as PropType<() => void>,
            required: true,
        },
    },

    setup(props) {
        return () => (
            <div class="logs-load-more-footer">
                {props.hasMore
                    ? (
                        <button
                            type="button"
                            class="logs-load-more-button"
                            disabled={props.loading}
                            onClick={() => props.onloadMore()}
                        >
                            {props.icon ? <span class="material-symbols-outlined">{props.icon}</span> : null}
                            {props.loading && <span class="logs-load-more-spinner" aria-hidden="true" />}
                            <span>{props.loading ? props.loadingLabel : props.label}</span>
                        </button>
                    )
                    : (
                        <div class="logs-load-more-end">
                            <span class="material-symbols-outlined">done_all</span>
                            <span>Aucun autre résultat</span>
                        </div>
                    )}
            </div>
        );
    },
});
